module.exports = "{{currentTime | secondsToString}}"